import {
   clsx
  ,styled
  ,Box
} from 'external/material'
import {isEmpty} from 'utils/text'

import useTranslations from 'hooks/translations'
import useSession from 'hooks/session'


const SectionContainer = styled(Box)(sectionStyles)
 
export default function Section ({sections}) {

  const {translate} = useTranslations()
  const {sectionId} = useSession()

  const sectionIndex = sections.findIndex(s => s.id == sectionId)
  const section = sectionIndex >= 0 && sections[sectionIndex]

  const title = isEmpty(section.title) ? `${translate('section')} ${sectionIndex + 1}` : section.title

  const instructions = section && (isEmpty(section.instructions) ? false: section.instructions)

  return (
    <SectionContainer key={section.id} className="root">
      <Box className="header">
        <Box className="title">{title}</Box>
      </Box>
      <Box className="content">
        <Box className="label">{translate('instructions')}</Box>
        {instructions && <div className="instructions" dangerouslySetInnerHTML={{__html: instructions}} />}
        {!instructions && <Box className="instructions">{translate('default-section-instructions')}</Box>}
      </Box>
    </SectionContainer>
  )
}

function sectionStyles() {
  return {
    "&.root": {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      color: '#525b6c',
    },
    "& .header": {
      display: 'flex',
      fontSize: '13pt',
      padding: '10px 20px',
      borderBottom: 'solid 1px #d0d5d8',
    },
    "& .content": {
      flexGrow: 1,
      overflowY: 'auto',
      padding: 30,
      display: 'flex',
      flexDirection: 'column',
    },
    "& .label": {
      fontWeight: 'bold',
      fontSize: '12pt',
      marginBottom: 40
    },
    "& .instructions": {
      fontSize: '11pt'
    }
  }
}
